import { render, staticRenderFns } from "./ChangeResolution.vue?vue&type=template&id=da21e26e&"
import script from "./ChangeResolution.vue?vue&type=script&lang=js&"
export * from "./ChangeResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da21e26e')) {
      api.createRecord('da21e26e', component.options)
    } else {
      api.reload('da21e26e', component.options)
    }
    module.hot.accept("./ChangeResolution.vue?vue&type=template&id=da21e26e&", function () {
      api.rerender('da21e26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/ChangeResolution.vue"
export default component.exports